import { TicketingLayout } from "@providers/checkout";
import type { ReactNode } from "react";

const Layout = ({
  children,
  showFooter: showFooter = false,
}: {
  children: ReactNode;
  showFooter?: boolean;
}) => {
  return (
    <TicketingLayout
      // bg="bg-[url('/images/bg.png')]"
      showFooter={true}
      allowToggleTheme={false}
    >
      {children}
    </TicketingLayout>
  );
};

export default Layout;
